import BenefitShowcaseCarousel from './BenefitShowcaseCarousel'

export default BenefitShowcaseCarousel
